import { ReactNode, useContext } from 'react';

import { GctlProvider, useGctlConfig } from '@vimeo/gctl-api/hooks/GctlProvider';

import { guestLoginModalContext } from './use-guestlogin-modal';
import { useAuthenticatedViewer } from './use-viewer';
import { CommentsContainerPropsType } from '../CommentsCommon/CommentsContainer';

export const GuestCommentsGctlProvider = ({ children }: { children: ReactNode }) => {
  const authenticatedViewer = useAuthenticatedViewer();
  const config = useGctlConfig();
  const { guestUser } = useContext(guestLoginModalContext);
  const guestJwt = guestUser ? JSON.parse(guestUser)?.guestUserJwt : null;

  return (
    <GctlProvider
      xVimeoPage={config.xVimeoPage}
      baseUrl={config.baseUrl}
      locale={config.locale}
      jwt={guestJwt && !authenticatedViewer ? guestJwt : config.jwt}
    >
      {children}
    </GctlProvider>
  );
};

export const withGctlProvider = (
  CommentsContainerComponent: React.FC<CommentsContainerPropsType>,
) => {
  return (props: CommentsContainerPropsType) => {
    return (
      <GuestCommentsGctlProvider>
        <CommentsContainerComponent {...props}></CommentsContainerComponent>
      </GuestCommentsGctlProvider>
    );
  };
};
